import { CoreLibService } from 'core-lib';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private coreLibService: CoreLibService) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwtToken = this.coreLibService.getJWTToken();
    if (jwtToken){
      if (req.method === 'PUT'){
        return next.handle(req);  
      }
      const modifiedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${jwtToken}`),
      });
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
}
